<template>
    <!-- Start Fun Facts Area -->
    <section class="funfacts-area ptb-80">
        <div class="container">
            <div class="section-title">
                <h2>We always try to make your guess and business model better</h2>
                <div class="bar"></div>
                <p>Talking to founders, investors and you is essential in developing better tools for everyone.</p>
            </div>

            
            <div class="row">
                <div class="col-lg-3 col-md-3 col-6 col-sm-3">
                    <div class="funfact">
                        <!--<h3><span class="odometer">
                            <IOdometer
                                class="odometer"
                                :value="contributors"
                                :duration="200"
                            />
                        </span>+</h3>-->
                        <h3>55+</h3>
                        <p>Business Model Patterns</p>
                    </div>
                </div>
                
                <div class="col-lg-3 col-md-3 col-6 col-sm-3">
                    <div class="funfact">
                        <!--<h3><span class="odometer">
                            <IOdometer
                                class="odometer"
                                :value="workers"
                                :duration="200"
                            />    
                        </span></h3>-->
                        <h3>18</h3>
                        <p>Customer Experience Elements</p>
                    </div>
                </div>

                <div class="col-lg-3 col-md-3 col-6 col-sm-3">
                    <div class="funfact">
                        <!--<h3><span class="odometer">
                            <IOdometer
                                class="odometer"
                                :value="feedback"
                                :duration="200"
                            />    
                        </span></h3>-->
                        <h3>44</h3>
                        <p>Educated Guessing Variables</p>
                    </div>
                </div>

                <div class="col-lg-3 col-md-3 col-6 col-sm-3">
                    <div class="funfact">
                        <!--<h3><span class="odometer">
                            <IOdometer
                                class="odometer"
                                :value="downloaded"
                                :duration="200"
                            />
                            </span>+</h3>-->
                        <h3>121+</h3>    
                        <p>Contributors</p>
                    </div>
                </div>
            </div>

            <div class="contact-cta-box">
                <h3>Curious?</h3>
                <p>Don't hesitate to contact us</p>
                <a href="mailto:team@educating-the-guess.com" class="btn btn-primary">Contact Us</a>
            </div>

            <!--<div class="map-bg">
                <img src="../../../assets/img/map.png" alt="map">
            </div>-->
           
        </div>
    </section>
    <!-- End Fun Facts Area -->
</template>

<script>
//import IOdometer from 'vue-odometer';
import 'odometer/themes/odometer-theme-default.css';

export default {
    name: 'Funfacts',
    data() {
        return {
            contributors: "55",
            workers: "18",
            feedback: "44",
            downloaded: "121",
        }
    },
    mounted() {
        const that = this;
        setInterval(function() {
            that.contributors += 1;
        }, 55);
        setInterval(function() {
            that.workers += 1;
        }, 500000);
        setInterval(function() {
            that.feedback += 1;
        }, 200000);
        setInterval(function() {
            that.downloaded += 1;
        }, 100000);
    },
    components: {
        //IOdometer
    }
}
</script>